<div
  class="alain-default__nav-item show-nav"
  nz-dropdown
  nzTrigger="click"
  nzPlacement="bottomRight"
  [nzDropdownMenu]="ellipsisMenu"
>
  <span nz-icon nzType="ellipsis" style="color: white;"></span>
</div>

<nz-dropdown-menu #ellipsisMenu="nzDropdownMenu">
  <div nz-menu class="width-sm header-extend">
    <div nz-menu-item (click)="openMarketplace()">
      <i
        nz-icon
        nzIconfont="icon-marketplace-black"
        style="color: white;"
        class="mr-sm"
      ></i>
      Marketplace
    </div>

    <div nz-menu-item (click)="requestAISupport.emit($event)">
      <i nz-icon nzType="customer-service" class="mr-sm"></i>
      Qbot AI Support
    </div>

    <div nz-menu-item (click)="requestChatbot.emit($event)">
      <div style="display: flex; align-items: center; gap: 10px;">
        <img
          src="https://cdn.qne.cloud/qca/assets/img/n3/Qbot-AI-Assistant.webp"
          alt="Qbot Chatbot"
          class="chat-icon"
          style="width: auto; height: 20px; cursor: pointer;"
        />
        <div>Qbot Chatbot</div>
      </div>
    </div>
    <div nz-menu-item (click)="openUrl()">
      <i nz-icon nzType="question-circle" class="mr-sm"></i>
      Support
    </div>
    @if (showSearchIcon()) {
      <div nz-menu-item (click)="requestSearch.emit($event)">
        <i nz-icon nzType="search" class="mr-sm"></i>
        Search
      </div>
    }
    <div nz-menu-item (click)="requestLock.emit($event)">
      <i nz-icon nzType="lock" class="mr-sm"></i>
      Lock
    </div>
  </div>
</nz-dropdown-menu>
